import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import loadable from '@loadable/component';

import { addEventListeners, removeEventListeners } from './eventListener';
import { getAPPID, getSession, isMoversFlow, removeSessionItem, setSession, setCookie, getCookie } from '../Helpers/index';
import { deleteAllCookies } from '../Helpers/cookies';
import * as sessionActions from './actions';
import saga from './sagas';
import injectSaga from '../../../utils/injectSaga';
import logger from '../ErrorBoundary/logger_new';
import { eventDispatcher } from '../Tagging';

import SessionTimeoutExisting from './SessionTimeoutExisting/index';

const SessionTimeOutProspect = loadable(() => import('./SessionTimeOutProspect'));

export const SessionOutModal = (props) => {
  const lastAccessedTime = new Date();

  const [isWarningModalOpen, setWarningModalOpen] = useState(false);
  const [isSessionTimeOut, setSessionTimeOut] = useState(false);
  const [initialTime, setInitialTime] = useState(lastAccessedTime);
  const [isJSNotifyforSessionTimeout, setisJSNotifyforSessionTimeout] = useState(true);
  const [sessionWarningTag, setsessionWarningTag] = useState(true);
  const [sessionTimeoutTag, setsessionTimeoutTag] = useState(true);

  const isLoggedIn = getAPPID() === 'AAL';

  const clearSession = () => {
    try {
      // new logic starts here for clearing session and redux
      const throttleVal = getSession('FWALqThrottle');
      window.sessionStorage.clear();
      if (window.vzFlags?.localStorage) {
        window.localStorage.clear();
      }
      window.localStorage.removeItem('state');
      
      // Delete cookies on session timeout - check cookie value
      const clearCookiesFlag = getCookie('clearCookiesOnSessionTimeout');
      if (clearCookiesFlag === 'Y') {
        deleteAllCookies();
      }
      setSession('sesExp', 'Y');
      setSession('FWALqThrottle', throttleVal);
      setCookie('prospectFwaCartExists', 'N');
      setCookie('FwaCartExists', 'N');
      const lqResponse = getSession('LQResponse');
      if (!lqResponse && isLoggedIn) {
        setCookie('loggedIn', false);
      }
    } catch (err) {
      window.location.hash = '#sessionTimeOut';
    }
  };

  const navigateToLandingPage = () => {
    logger({
      json: true,
      eventType: 'FeInfo',
      message: 'Session Timeout Click',
      note: 'from sessionTimeout metthod click',
      messageType: 'INFO',
    });
    props.sessionLogoff();
    if(!isMoversFlow()) clearSession();

    setWarningModalOpen(false);
    if(!isMoversFlow()) setSession('sesExp', 'Y'); // sesExp means session Expires
    window.location.href = props.landingPageUrl;
  };

  const onClickLoginHandler = (e) => {
    if(isMoversFlow()) {
      removeSessionItem('sesExp')
      setSessionTimeOut(false);
    };
    e.preventDefault();
    navigateToLandingPage();
  };

  const skipInitialRendering = useRef(true);
  useEffect(() => {
    if (skipInitialRendering.current) {
      skipInitialRendering.current = false;
    } else {
      logger({
        json: true,
        eventType: 'FeInfo',
        message: 'Session Extension Method Call',
        note: 'call from session extension',
        messageType: 'INFO',
      });
      setWarningModalOpen(false);
    }
  }, [props.timerToggleFlag]);

  const [timeLeft, setTimeLeft] = useState('');

  const addPad = (number) => (number < 10 ? `0${number}` : number);

  useEffect(() => {
    const minsDiff = (new Date().getTime() - initialTime.getTime()) / 60000;

    if (isWarningModalOpen) {
      const logoffShowTime = parseInt(props.warning) + 1;
      if (minsDiff > logoffShowTime) {
        setSessionTimeOut(true);
      } else {
        let timer = Number(props.timeout - props.warning) * 60;
        let minutes;
        let secondsS;
        const interval = setInterval(() => {
          minutes = parseInt(timer / 60);
          secondsS = parseInt(timer % 60);
          setTimeLeft(`${addPad(minutes)}:${addPad(secondsS)}`);

          // eslint-disable-next-line no-plusplus
          if (--timer < 0) {
            timer = Number(props.timeout - props.warning) * 60;
          }
        }, 1000);
        return () => {
          setInitialTime(new Date());
          clearInterval(interval);
          setTimeLeft(
            `${addPad(parseInt((Number(props.timeout - props.warning) * 60) / 60))}:${parseInt((Number(props.timeout - props.warning) * 60) % 60)}`,
          );
        };
      }
    }
  }, [isWarningModalOpen]);

  useEffect(() => {
    // remove_hash_from_url();
    // if (getSession('sesExp') === 'Y') {
    //   navigateToLandingPage();
    //   return;
    // }
    const interval = setInterval(
      () => {
        props.sessionKeepAliveSilent();
      },
      Number(props.warning) * 60 * 1000,
    );
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if(isMoversFlow() && getSession('sesExp') === 'Y') setWarningModalOpen(true);
    const createTimeout1 = () =>
      setTimeout(
        () => {
          setWarningModalOpen(true);
        },
        Number(props.warning) * 60 * 1000,
      );

    const createTimeout2 = () =>
      setTimeout(
        () => {
          setSessionTimeOut(true);
        },
        (isMoversFlow() && getSession('sesExp') === 'Y') ? 0 : Number(props.timeout - props.warning) * 60 * 1000,
      );

    let timeout = isWarningModalOpen ? createTimeout2() : createTimeout1();

    const listener = () => {
      if (!isWarningModalOpen) {
        clearTimeout(timeout);
        timeout = createTimeout1();
        setInitialTime(new Date());
      }
    };

    // Initialization
    addEventListeners(listener);

    return () => {
      removeEventListeners(listener);
      clearTimeout(timeout);
    };
  }, [isWarningModalOpen]);

  if (isWarningModalOpen && !isSessionTimeOut) {
    if (sessionWarningTag) {
      const sessionWarning = {
        name: 'session warning',
        selector: 'sessionWarning',
      };
      eventDispatcher('openView', sessionWarning);
      setsessionWarningTag(false);
    }
    window.location.hash = '#sessionWarning';
  }

  if (isSessionTimeOut) {
    if (isJSNotifyforSessionTimeout) {
      logger({
        json: true,
        eventType: 'FeInfo',
        message: 'Session Timeout Click test',
        note: 'from sessionTimeout metthod click test',
        messageType: 'INFO',
      });
      setisJSNotifyforSessionTimeout(false);
    }
    clearSession();
    if (isLoggedIn) {
      if (sessionTimeoutTag) {
        const objectName = { name: 'session timeout', selector: 'sessionTimeOut' };
        eventDispatcher('openView', objectName);
        setsessionTimeoutTag(false);
      }
    } else if (sessionTimeoutTag) {
      const sessionTimeOut = {
        name: 'session expiry',
        selector: 'sessionExpiry',
      };
      eventDispatcher('openView', sessionTimeOut);
      setsessionTimeoutTag(false);
    }
  }

  const skipInitialRenderingHash = useRef(true);

  useEffect(() => {
    if (skipInitialRenderingHash.current) {
      skipInitialRenderingHash.current = false;
    } else if (!isWarningModalOpen) {
      remove_hash_from_url();
    }
  }, [isWarningModalOpen]);

  function remove_hash_from_url() {
    const uri = window.location.toString();

    if (uri.indexOf('#') > 0) {
      const clean_uri = uri.substring(0, uri.indexOf('#'));
      window.history.replaceState({}, document.title, clean_uri);
    }
  }

  if (!isWarningModalOpen) {
    return null;
  }

  if (!isLoggedIn) {
    return (
      <SessionTimeOutProspect
        isOpen={isWarningModalOpen}
        sessionTimedOut={isSessionTimeOut}
        onLogoff={onClickLoginHandler}
        sessionKeepAlive={props.sessionKeepAlive}
        timeLeft={timeLeft}
      />
    );
  }
  return (
    <SessionTimeoutExisting
      isOpen={isWarningModalOpen}
      sessionTimedOut={isSessionTimeOut}
      onLogoff={onClickLoginHandler}
      sessionKeepAlive={props.sessionKeepAlive}
      timeLeft={timeLeft}
    />
  );
};

SessionOutModal.propTypes = {
  timeout: PropTypes.string,
  warning: PropTypes.string,
  landingPageUrl: PropTypes.string,
  timerToggleFlag: PropTypes.bool,
  sessionKeepAlive: PropTypes.func,
  sessionLogoff: PropTypes.func,
  sessionKeepAliveSilent: PropTypes.func,
};

const mapStateToProps = (state) => {
  const { sessionExtension = {} } = state;
  const { timerToggleFlag = false } = sessionExtension;
  return { timerToggleFlag };
};

const withSaga = injectSaga({ key: 'session', saga });

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...sessionActions,
    },
    dispatch,
  );

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withSaga, withConnect)(SessionOutModal);